import { setTerm } from './helpers';

export const setFurniture = setTerm('has_furniture');
